import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { X, ChevronRight, Truck, RefreshCw, FileText, Shield } from "lucide-react";

const menuItems = [
  { path: "/delivery", label: "Условия доставки", icon: Truck },
  { path: "/returns", label: "Возврат / обмен", icon: RefreshCw },
  { path: "/offer", label: "Публичная оферта", icon: FileText },
  { path: "/privacy", label: "Политика обработки персональных данных", icon: Shield },
];

const HamburgerMenu = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      requestAnimationFrame(() => setAnimating(true));
    } else {
      setAnimating(false);
      const t = setTimeout(() => setVisible(false), 320);
      return () => clearTimeout(t);
    }
  }, [isOpen]);

  const handleNavigate = (path) => {
    onClose();
    setTimeout(() => navigate(path), 200);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50" data-testid="hamburger-menu-overlay">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300"
        style={{ opacity: animating ? 1 : 0 }}
        onClick={onClose}
      />

      {/* Menu panel */}
      <div
        className="absolute top-0 right-0 h-full w-[85%] max-w-[340px] bg-[#F5F0EB] shadow-2xl transition-transform duration-300 ease-out"
        style={{ transform: animating ? "translateX(0)" : "translateX(100%)" }}
        data-testid="hamburger-menu-panel"
      >
        {/* Header */}
        <div className="flex items-center justify-between pt-14 pb-6 px-6">
          <h2
            className="font-serif text-[20px] text-[#1A1A1A] font-medium tracking-tight"
            data-testid="menu-title"
          >
            Информация
          </h2>
          <button
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1A1A1A]/5 active:bg-[#1A1A1A]/10 transition-colors"
            data-testid="menu-close-button"
          >
            <X size={18} className="text-[#1A1A1A]/70" strokeWidth={2} />
          </button>
        </div>

        {/* Divider */}
        <div className="mx-6 h-px bg-[#1A1A1A]/8" />

        {/* Menu Items */}
        <nav className="px-4 pt-4" data-testid="menu-nav">
          {menuItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <button
                key={item.path}
                onClick={() => handleNavigate(item.path)}
                className="w-full flex items-center gap-4 px-3 py-4 rounded-2xl hover:bg-[#1A1A1A]/[0.03] active:bg-[#1A1A1A]/[0.06] transition-colors text-left group"
                style={{ animationDelay: `${index * 50}ms` }}
                data-testid={`menu-item-${item.path.slice(1)}`}
              >
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-[#1A1A1A]/[0.05]">
                  <Icon size={18} className="text-[#1A1A1A]/60" strokeWidth={1.5} />
                </div>
                <span className="flex-1 font-sans text-[14px] text-[#1A1A1A]/80 font-medium leading-snug">
                  {item.label}
                </span>
                <ChevronRight size={16} className="text-[#1A1A1A]/25 group-hover:text-[#1A1A1A]/40 transition-colors flex-shrink-0" strokeWidth={2} />
              </button>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="absolute bottom-8 left-0 right-0 px-6">
          <div className="h-px bg-[#1A1A1A]/8 mb-4" />
          <p className="text-[11px] font-sans text-[#1A1A1A]/30 text-center tracking-wide">
            Shoemaster USA
          </p>
        </div>
      </div>
    </div>
  );
};

export default HamburgerMenu;
